export const formatName = (firstName?: string | null, lastName?: string | null) => {
    switch(true) {
        case !!(firstName && lastName):
            return `${(firstName as string).toUpperCase()[0]}.${lastName}`;
        case !!(firstName): 
            return firstName;
        default:
            return lastName;
    } 
}